import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShieldCheck, ArrowLeft, AlertTriangle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const authError = location.state?.authError;

  useEffect(() => {
    if (!loading && user) navigate("/command/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/command/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#1A2421] text-white">
      <div className="relative hidden lg:block overflow-hidden">
        <img src="https://images.unsplash.com/photo-1758304481551-25138093050b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#1A2421] via-[#1A2421]/60 to-transparent" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-2.5">
            <img src="/logo-full-white.png" alt="West Face Roofing & Projects" className="h-11 w-auto" />
          </div>
          <div>
            <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-3">Command Center</p>
            <h1 className="font-display font-black text-4xl lg:text-5xl leading-none">Run the business<br />from one screen.</h1>
            <p className="mt-5 text-white/60 max-w-sm">Leads, team, finances and your AI crew — all in one place. Owner access only.</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-16">
        <a href="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm font-semibold mb-10"><ArrowLeft size={16} /> Back to website</a>
        <div className="grid place-items-center w-14 h-14 rounded-2xl bg-[#62B848]/15 text-[#62B848] mb-6"><ShieldCheck size={28} /></div>
        <h2 className="font-display font-extrabold text-3xl mb-2">Owner login</h2>
        <p className="text-white/60 mb-8">Sign in with your Google account to access the West Face command center.</p>
        {authError && (
          <div data-testid="auth-error" className="flex items-start gap-3 rounded-2xl bg-red-500/10 border border-red-500/30 text-red-200 px-4 py-3.5 mb-6 text-sm">
            <AlertTriangle size={18} className="shrink-0 mt-0.5" />
            <span>{authError}</span>
          </div>
        )}
        <button data-testid="google-login-btn" onClick={login}
          className="inline-flex items-center justify-center gap-3 bg-white text-[#1A2421] font-bold px-6 py-4 rounded-full hover:bg-white/90 transition-colors">
          <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continue with Google
        </button>
        <p className="text-xs text-white/40 mt-6">Authorised personnel only. All actions are logged.</p>
      </div>
    </div>
  );
}
